<template>
  <div>
<lk-form-item label='医保类型'>
  <lk-radio-group v-model="type">
                <lk-radio :label='1' >慢病医保</lk-radio>
              </lk-radio-group>
<lk-button size='small' type='primary' @click="handleQRCode">生成二维码</lk-button>
<div v-if="QRCodeList.length">

 <canvas v-for="(item,index) in QRCodeList" :key="index" :ref="'QRCode'+index" ></canvas>
</div>
</lk-form-item>
  </div>
</template>
<script>
import QRCode from 'qrcode';

export default {
  name: 'KunMingPayComp',
  data() {
    return {
      type: 1,
      QRCodeList: [],
    };
  },
  methods: {
    handleQRCode() {
      this.QRCodeList = [];
      this.QRCodeList.push('测试二维码,测试二维码,测试二维码,测试二维码,测试二维码,测试二维码,');
      // setTimeout(() => {
      this.$nextTick(() => {
        this.QRCodeList.forEach((item, index) => {
          const canvas = this.$refs[`QRCode${index}`][0];
          console.log(canvas);

          QRCode.toCanvas(canvas, item, {
            width: 320,
          }, (error) => {
            if (error) console.error(error);
            console.log('success!');
          });
        });
      });
      // }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>

</style>
